import React from 'react';
import TextFieldClient from '../../components/TextFieldClient';
import { pad, renderDate, renderMoney, dateRangeFilter } from '../../../common/services/util';
import { Tooltip } from '@material-ui/core';
import { EuroSymbol } from '@material-ui/icons';
import Description from '@material-ui/icons/Description';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import paqueteEntregado from 'common/assets/paquete_entregado.png';
import { Button } from '@material-ui/core';
import DateRangeFilter from 'common/components/DateRangeFilter';

const states = {
    0: 'En diagnóstico',
    1: 'Enviado al exterior',
    2: 'Reparado',
    3: 'Esperando repuesto',
    4: 'Sin reparar',
    5: 'Reparando',
    6: 'Pendiente confirmación',
    7: 'En tránsito'
};

export const stateColors = {
    0: '#FA4C4C', // Rojo - En diagnóstico
    1: '#D07F59', // Marron - Enviado al exterior
    2: '#4cc488ff', // Verde - Reparado
    3: '#d4d457ff', // Amarillo - Esperando repuesto
    4: '#c3c3c3', // Gris - Sin reparar
    5: '#ff9966', // Naranja - Reparando
    6: '#87CEEB', // Azul - Pendiente confirmación
    7: '#b39ddb', // Morado claro - En tránsito
    99: '#39ff14' // Verde fuerte (pagado)
};

const textFieldClient = (props, timeout, placeholder, isEditable = false) => {
    return (
        <TextFieldClient props={props} timeout={timeout} placeholder={placeholder} isEditable={isEditable} />
    )
}

export const getColumns = (checkedPaid, checkedInvoiced, checkedBudget, searchClient, reference, checkedMaxImp, checkedSelected, selectState, orderColumns = {}, checkAll, checkedCollected, checkedTaskIva) => {
    const columns = [
        { 
            title: '', 
            field: 'selected', 
            render: props => checkedSelected(props),
            editable: 'never', 
            cellStyle: { width: '30px'},
            filterComponent: () => checkAll()
        },
        { 
            title: 'Referencia', 
            field: 'reference', 
            editable: 'onUpdate', 
            render: rowData => reference(rowData)
        },
        { 
            title: 'DNI', 
            field: 'dni', 
            editComponent: searchClient, 
            render: rowData => renderBold(rowData.dni, rowData.maxImportance)
        },
        { 
            title: 'Cliente', 
            field: 'clientName', 
            editComponent: props => textFieldClient(props, 0, 'Cliente'),
            render: rowData => 
                <div style={{ width: '150px' }}>
                    { renderBold(rowData.clientName, rowData.maxImportance) }
                    { rowData.numberTasks >= 2 && rowData.numberTasks <= 5 && `🔁` }
                    { rowData.numberTasks > 5 && `⭐` }
                </div>
        },
        {
            title: 'Ref. Cliente',
            field: 'refClient',
            render: rowData => renderBold(rowData.refClient, rowData.maxImportance)
        },
        {
            title: 'Dispositivo',
            field: 'deviceName',
            render: rowData => {
                const tr = rowData.testResults
                const hasDoneTest = tr && Object.keys(tr).length > 0
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        {hasDoneTest && (
                            <span style={{
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                background: '#fff', borderRadius: 4, padding: 2,
                                boxShadow: '0 1px 3px rgba(0,0,0,0.25)', flexShrink: 0
                            }}>
                                <AssignmentTurnedInIcon style={{ fontSize: 14, color: '#43a047' }} />
                            </span>
                        )}
                        {renderBold(rowData.deviceName, rowData.maxImportance)}
                    </div>
                )
            }
        },
        { 
            title: 'Avería', 
            field: 'description',
            render: rowData => renderBold(rowData.description, rowData.maxImportance)
        },
        { 
            title: 'Estado', 
            field: 'state', 
            lookup: states, 
            editable: 'onUpdate', 
            render: rowData => <div style={{ width: '210px' }}>
                                    { rowData && selectState({ rowData, states, value: rowData.state }) }
                                </div>
        },
        {
            title: 'Fecha entrada',
            field: 'dateEntry',
            type: 'date',
            editable: 'never',
            filterComponent: props => <DateRangeFilter {...props} />,
            customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData.dateEntry),
            render: rowData => {
                if (!rowData || !rowData.dateEntry) return '';
                const [date, time] = renderDate(rowData.dateEntry, true).split(' ');
                const fw = rowData.maxImportance ? 'bold' : 'initial';
                return <div style={{ textAlign: 'center', width: '100px' }}>
                    <div style={{ fontWeight: fw }}>{date}</div>
                    <div style={{ fontSize: 11, color: '#757575', fontWeight: fw }}>{time}</div>
                </div>;
            }
        },
        {
            title: 'Fecha salida',
            field: 'dateFinish',
            type: 'date',
            editable: 'never',
            filterComponent: props => <DateRangeFilter {...props} />,
            customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData.dateFinish),
            render: rowData => {
                if (!rowData || !rowData.dateFinish) return '';
                const [date, time] = renderDate(rowData.dateFinish, true).split(' ');
                const fw = rowData.maxImportance ? 'bold' : 'initial';
                return <div style={{ textAlign: 'center', width: '100px' }}>
                    <div style={{ fontWeight: fw }}>{date}</div>
                    <div style={{ fontSize: 11, color: '#757575', fontWeight: fw }}>{time}</div>
                </div>;
            }
        },
        {
            title: <Tooltip title="IVA incluido en el presupuesto"><span>IVA</span></Tooltip>,
            field: 'iva',
            render: props => checkedTaskIva(props),
            editable: 'never',
            filtering: false,
            sorting: false,
            cellStyle: { width: 60, minWidth: 60, maxWidth: 60, padding: '0 4px', textAlign: 'center' },
            headerStyle: { textAlign: 'center' },
        },
        {
            title: 'Presupuesto',
            field: 'budget',
            render: props => checkedBudget(props, props.maxImportance, props.payed),
            type: 'numeric'
        },
        {
            title: 'Fecha aceptación',
            field: 'dateAccepted',
            type: 'date',
            editable: 'never',
            filterComponent: props => <DateRangeFilter {...props} />,
            customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData?.dateAccepted),
            render: rowData => {
                if (!rowData?.dateAccepted) return '';
                const [date, time] = renderDate(rowData.dateAccepted, true).split(' ');
                const fw = rowData.maxImportance ? 'bold' : 'initial';
                return <div style={{ textAlign: 'center', width: '100px' }}>
                    <div style={{ fontWeight: fw }}>{date}</div>
                    <div style={{ fontSize: 11, color: '#757575', fontWeight: fw }}>{time}</div>
                </div>;
            }
        },
        {
        title: <Tooltip title="Cobrado"><EuroSymbol fontSize="small" /></Tooltip>,
        field: 'payed',
        lookup: { 0: 'Sin cobrar', 1: 'Cobrado' },
        customFilterAndSearch: (term, rowData) => {
            if (term.length === 0 || term.length > 1) return true;
            return Boolean(parseInt(term[0])) === Boolean(rowData.payed);
        },
        render: props => (
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
            {checkedPaid(props)}
            </div>
        ),
        editable: 'never',
        cellStyle:  { width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        headerStyle:{ width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        },
        {
        title: <Tooltip title="Facturado"><Description fontSize="small" /></Tooltip>,
        field: 'invoiced',
        lookup: { 0: 'Sin facturar', 1: 'Facturado' },
        customFilterAndSearch: (term, rowData) => {
            if (term.length === 0 || term.length > 1) return true;
            return Boolean(parseInt(term[0])) === Boolean(rowData.invoiced);
        },
        render: props => (
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
            {checkedInvoiced(props)}
            </div>
        ),
        editable: 'never',
        cellStyle:  { width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        headerStyle:{ width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        },
        {
        title: <Tooltip title="Recogido"><img src={paqueteEntregado} alt="Recogido" style={{ width: 18, height: 18, filter: 'grayscale(1) opacity(0.54)' }} /></Tooltip>,
        field: 'collected',
        lookup: { 0: 'Sin recoger', 1: 'Recogido' },
        customFilterAndSearch: (term, rowData) => {
            if (term.length === 0 || term.length > 1) return true;
            return Boolean(parseInt(term[0])) === Boolean(rowData.collected);
        },
        render: props => (
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
            {checkedCollected && checkedCollected(props)}
            </div>
        ),
        editable: 'never',
        cellStyle:  { width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        headerStyle:{ width: 48, minWidth: 48, maxWidth: 48, padding: '0 4px', textAlign: 'center' },
        },
        {
            title: 'Teléfono',
            field: 'phone',
            editComponent: props => textFieldClient(props, 10, 'Teléfono', true),
            render: rowData => renderBold(rowData.phone, rowData.maxImportance)
        },
        {
            title: 'Email',
            field: 'mail',
            editComponent: props => textFieldClient(props, 0, 'Email', true),
            render: rowData => renderBold(rowData.mail, rowData.maxImportance)
        },
        { 
            title: 'Desbloqueo', 
            field: 'unlockCode', 
            render: rowData => renderBold(rowData.unlockCode, rowData.maxImportance)
        },
        { 
            title: 'IMEI', 
            field: 'imei', 
            render: rowData => renderBold(rowData.imei, rowData.maxImportance)
        },
        { 
            title: 'Max. Imp.', 
            field: 'maxImportance', 
            render: props => checkedMaxImp(props),
            filtering: false
        },
        { 
            title: 'Fecha entrada ordenacion', 
            field: 'dateEntryOrder', 
            type: 'numeric', 
            defaultSort: 'desc', 
            hidden: true 
        },
        { 
            title: 'Fecha firma ordenacion', 
            field: 'dateEntrySign', 
            type: 'date', 
            hidden: true 
        }
    ]

    return columns
        .map(col => {
            const columnOrder = orderColumns[col.field]

            if (!columnOrder && columnOrder !== 0) {
                return col
            }

            col.tableData = {
                columnOrder
            }
            return col
        })
}

const renderBold = (value, maxImportance) => {
    return <span style={{ fontWeight: maxImportance ? 'bold' : 'initial' }}>{ value }</span>
}

export const getColorState = task => {
    return stateColors[task.state] ? stateColors[task.state] : '';
}

export const applyDefaultCreated = (task, reference) => {
    task.dateEntry = new Date().getTime();
    if (task.state === undefined || task.state === null) {
    task.state = 0;
    }
    task.payed = 0;
    task.invoiced = 0;
    task.reference = pad(reference, 4);
}

export const checkIsFinalize = (newTask, oldTask) => {
    if (newTask.payed === "1" && oldTask.payed !== 1) {
        newTask.dateFinish = new Date().getTime();
    }
}

